import * as React from 'react';
import ContractSearch from './ContractSearch';
import EntitySelectionDlg from './EntitySelectionDlg';


function ContractSelectionDlg(props) {
  const {
    children,
    ...otherProps
  } = props;
  return (
    <EntitySelectionDlg
      {...otherProps}
      searchComp={ContractSearch}
      dialogTitle="Select Contracts"
    />
  );
}

ContractSelectionDlg.propTypes = {
  ...EntitySelectionDlg.propTypes,
};

ContractSelectionDlg.defaultProps = {
  ...EntitySelectionDlg.defaultProps,
};

export default ContractSelectionDlg;
